import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageBanner from "@/components/PageBanner";
import { Mail, ShieldCheck, Phone } from "lucide-react";
import { toast } from "sonner";

const CONTACTS = [
  { i: Phone,       l: "Helpline",            v: "+91 90601 28999",       note: "10:00 AM – 6:00 PM · Mon–Sat",             href: "tel:+919060128999" },
  { i: Mail,        l: "General Enquiries",   v: "info@samarawiz.com",    note: "Product · Business plan · Franchise",     href: "mailto:info@samarawiz.com" },
  { i: ShieldCheck, l: "Support & Payouts",   v: "support@samarawiz.com", note: "Orders · Wallet · KYC · Payouts",         href: "mailto:support@samarawiz.com" },
];

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PageBanner
        label="Contact Us"
        title="Talk to Samara Wiz."
        subtitle="Have a question about products, our business plan, or a franchise partnership? Our team is one message away."
        crumbs={[{ label: "Home", to: "/" }, { label: "Contact Us" }]}
      />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Helpline + Email contacts */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {CONTACTS.map((x, i) => (
            <a key={x.l} href={x.href} data-testid={`contact-card-${i}`} className="bg-white border border-line p-6 rounded-sm hover:border-gold/40 transition-colors block">
              <x.i className="text-gold-deep" size={22} />
              <div className="text-[10px] uppercase tracking-widest text-navy/50 mt-4">{x.l}</div>
              <div className="text-royal font-medium mt-1">{x.v}</div>
              <div className="text-[11px] text-navy/50 mt-2">{x.note}</div>
            </a>
          ))}
        </div>

        {/* Form */}
        <form onSubmit={(e) => { e.preventDefault(); toast.success("Message received! We'll get back within 24 hours."); }} className="mt-10 bg-white border border-line p-8 lg:p-10 rounded-sm shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input data-testid="contact-name" required placeholder="Your name" className="border border-line px-4 py-3 text-sm rounded-sm focus:border-gold focus:outline-none" />
            <input data-testid="contact-email" required type="email" placeholder="Email address" className="border border-line px-4 py-3 text-sm rounded-sm focus:border-gold focus:outline-none" />
            <input data-testid="contact-subject" required placeholder="Subject" className="md:col-span-2 border border-line px-4 py-3 text-sm rounded-sm focus:border-gold focus:outline-none" />
            <textarea data-testid="contact-message" required placeholder="How can we help?" rows={5} className="md:col-span-2 border border-line px-4 py-3 text-sm rounded-sm focus:border-gold focus:outline-none" />
          </div>
          <button data-testid="contact-submit" className="mt-6 bg-royal text-white px-7 py-3 hover:bg-royal-deep rounded-sm inline-flex items-center gap-2">
            Send Message
          </button>
          <div className="text-xs text-navy/50 mt-3">Have a complaint? Please use our dedicated <a href="/grievance" className="text-royal underline hover:text-gold">Grievance Redressal</a> form.</div>
        </form>
      </section>
      <Footer />
    </div>
  );
}
